import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {
  GetImportExportLiteralsSuccess,
  LocaleGridSuccess,
  NewLiteralsPagingChanged,
  NewLiteralsPerPageChanged,
} from 'src/app/modules/administration/locale-management/actions/import-export-literals.actions';
import {
  GetSearchLiteralsSuccess,
  LiteralsPagingChanged,
  LiteralsPerPageChanged,
  SearchLiteralsGridSuccess,
} from 'src/app/modules/administration/locale-management/actions/search-literals.actions';
import { GridSearch } from '../actions/grid.actions';
import { EliquaFacadeService } from '../services/eliqua.facade.service';
import { GridFacadeService } from '../services/grid.facade.service';
import { PaginatorFacadeService } from '../services/paginator.facade.service';

@Injectable()
export class GridEffects {
  constructor(
    private actions$: Actions,
    private eliquaFacadeService: EliquaFacadeService,
    private gridFacadeService: GridFacadeService,
    private paginatorFacadeService: PaginatorFacadeService,
  ) {}

  gridSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GridSearch),
      switchMap(() => this.eliquaFacadeService.serviceSelect()),
    ),
  );

  newItemLiteralSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NewLiteralsPerPageChanged),
      switchMap(({ itemsNumber }) => {
        const startIndex = this.paginatorFacadeService.pageIndex * itemsNumber;
        const endIndex = startIndex + itemsNumber;

        const fullData = this.gridFacadeService.newLiteralsData;

        const paginatedData = fullData.slice(startIndex, endIndex).map((literal) => ({
          ...literal,
          isSelectedLiteral: true,
        }));

        return of(
          GetImportExportLiteralsSuccess({ res: fullData }),
          LocaleGridSuccess({ res: paginatedData }),
        );
      }),
    ),
  );

  newItemLiteralsPagingChanged$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NewLiteralsPagingChanged),
      switchMap(({ paginator }) => {
        const startIndex = paginator.pageIndex * this.paginatorFacadeService.itemsNumber;
        const endIndex = startIndex + this.paginatorFacadeService.itemsNumber;

        const fullData = this.gridFacadeService.newLiteralsData;

        const paginatedData = fullData.slice(startIndex, endIndex).map((literal) => ({
          ...literal,
          isSelectedLiteral: true,
        }));

        return of(LocaleGridSuccess({ res: paginatedData }));
      }),
    ),
  );

  itemLiteralSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LiteralsPerPageChanged),
      switchMap(({ itemsNumber }) => {
        const startIndex = this.paginatorFacadeService.pageIndex * itemsNumber;
        const endIndex = startIndex + itemsNumber;

        const fullData = this.gridFacadeService.literalsData;

        const paginatedData = fullData.slice(startIndex, endIndex).map((literal) => ({
          ...literal,
        }));

        return of(
          GetSearchLiteralsSuccess({ res: fullData }),
          SearchLiteralsGridSuccess({ res: paginatedData }),
        );
      }),
    ),
  );

  itemLiteralsPagingChanged$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LiteralsPagingChanged),
      switchMap(({ paginator }) => {
        const startIndex = paginator.pageIndex * this.paginatorFacadeService.itemsNumber;
        const endIndex = startIndex + this.paginatorFacadeService.itemsNumber;

        const fullData = this.gridFacadeService.literalsData;

        const paginatedData = fullData.slice(startIndex, endIndex).map((literal) => ({
          ...literal,
        }));

        return of(SearchLiteralsGridSuccess({ res: paginatedData }));
      }),
    ),
  );
}
